import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}events/`;

export function getEvents(searchCriteria) {
    var url = baseUrl + "search";

    return fetch(url, { method: "POST", body: JSON.stringify(searchCriteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getUserEvents() {
    var url = baseUrl + "getuserevents";

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}


export function getUpcomingUserEvents(number) {
    var url = `${baseUrl}getupcominguserevents/${number}`;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getGroupEvents(groupId) {
    var url = baseUrl + `getgroupevents/${groupId}`;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}


export function getEvent(id) {
    var url = baseUrl + id;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function saveEvent(event) {
    return fetch(baseUrl + (event.id || ""),
        {
            method: event.id ? "PUT" : "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(event),
            credentials: "include"
        })
        .then(handleResponse)
        .catch(handleError);
}

export function deleteEvent(id) {
    var url = baseUrl + id;

    return fetch(url, { method: "DELETE", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}


export function cancelEvent(id, cancellationReason) {
    var url = `${baseUrl}cancelevent`;
    var eventCancellation = { id: id, reason: cancellationReason };

    return fetch(url, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(eventCancellation), credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function setUserParticipation(eventId, user, status) {
    var url = `${baseUrl}setparticipationstatus`;
    var eventCancellation = { eventId: eventId, user: user, status: status };

    return fetch(url, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(eventCancellation), credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}


// WEBPACK FOOTER //
// ./src/api/eventsApi.js